var ret = {};
if (process.env.VUE_APP_ENV === "develop") {
  ret = require("./config/develop");
} else if (process.env.VUE_APP_ENV === "staging") {
  ret = require(`./config/staging-ao`);
} else if (process.env.VUE_APP_ENV === "production") {
  ret = require(`./config/production-ao`);
} else {
  ret = require(`./config/unitTest`);
}
ret.systemName = "touch-mee";
module.exports = ret;
